(function ($) {
    $(function () {

                /**
                 * Footer Social Counts
                 */

                /* Facebook */
                $('.connect-facebook').on('click', function (e) {
                    e.preventDefault();

                    $('.connect-twitter-menu').hide();

                    $([
                        {
                            account: 'nativeinstruments',
                            cssID: '#facebook-ni-count',
                            toggle: false
                        },
                        {
                            account: 'nikomplete',
                            cssID: '#facebook-komplete-count',
                            toggle: false
                        },
                        {
                            account: 'traktorpro',
                            cssID: '#facebook-traktor-count',
                            toggle: false
                        },
                        {
                            account: 'nimaschine',
                            cssID: '#facebook-maschine-count',
                            toggle: false
                        },
                        {
                            account: 'playstems',
                            cssID: '#facebook-stems-count',
                            toggle: true
                        },
                        {
                            account: 'nativeinstrumentsjapan',
                            cssID: '#facebook-tokyo-count',
                            toggle: false
                        }
                    ]).each(function (index, elm) {
                        $.ajax({
                            url: Util.getWwwDomain() + '/typo3conf/ext/ni_assets/Resources/Public/Scripts/facebookProxy.php?account=' + elm.account,
                            dataType: 'jsonp',
                            success: function (data) {
                                $(elm.cssID).text(data.likes ? Util.formatCount(data.likes) + ' Likes' : '');
                                if (elm.toggle) {
                                    $('.connect-facebook-menu').toggle();
                                }
                            }
                        });
                    });
                });

                /* Twitter */
                $('.connect-twitter').on('click', function (e) {
                    e.preventDefault();

                    $('.connect-facebook-menu').hide();

                    $([
                        {
                            account: 'tokyo_ni',
                            cssID: '#twitter-tokyo-count',
                            toggle: false
                        },
                        {
                            account: 'NI_News',
                            cssID: '#twitter-news-count',
                            toggle: false
                        },
                        {
                            account: 'Komplete',
                            cssID: '#twitter-komplete-count',
                            toggle: false
                        },
                        {
                            account: 'Traktor',
                            cssID: '#twitter-traktor-count',
                            toggle: false
                        },
                        {
                            account: 'NI_Maschine',
                            cssID: '#twitter-maschine-count',
                            toggle: false
                        },
                        {
                            account: 'NI_Job',
                            cssID: '#twitter-jobs-count',
                            toggle: true
                        }
                    ]).each(function (index, elm) {
                        $.ajax({
                            url: Util.getWwwDomain() + '/typo3conf/ext/ni_assets/Resources/Public/Scripts/twitterProxy.php?url=' + encodeURIComponent('users/show.json?screen_name=' + elm.account),
                            dataType: 'jsonp',
                            success: function (data) {
                                $(elm.cssID).text(data.followers_count ? Util.formatCount(data.followers_count) + ' Followers' : '');
                                if (elm.toggle) {
                                    $('.connect-twitter-menu').toggle();
                                }
                            }
                        });
                    });
                });

            }
    );
})(jQuery);
